import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useShare } from "@/hooks";
import { getFeaturesEnabled } from "@/utils";
import { Box } from "@gemini/core";
import { CopyIcon, UploadIcon } from "@gemini/icons";
import { FavoriteCTA } from "./components/FavoriteCTA";
import { PrintCTA } from "./components/PrintCTA";
import { ShareCTA } from "./components/ShareCTA";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const SocialAndPrintCTAs = ({ dark, showPrint = false, showBorder = false, variant, isDesktop, }) => {
    const { copyShare, nativeMobileShare } = useShare();
    const { favorites } = getFeaturesEnabled();
    const isPreviewMode = useIsPreviewMode();
    return (_jsxs(Box, { as: "div", display: "flex", gap: isDesktop ? "spacing.8" : "spacing.none", height: "sizing.40", minWidth: {
            "breakpoint.base": "sizing.80",
            "breakpoint.lg": showPrint ? "sizing.142" : "sizing.96",
        }, alignItems: "flex-start", justifyContent: "right", id: "favoriteAndShareCTAs", marginLeft: "auto", onClick: (e) => {
            e.stopPropagation(); // Prevent click event from parent (ex : to avoid image preview click to open the modal)
        }, children: [showPrint && isDesktop && _jsx(PrintCTA, { variant: variant }), _jsx(ShareCTA, { onPress: isDesktop ? copyShare : nativeMobileShare, icon: isDesktop ? CopyIcon : UploadIcon, variant: variant }), favorites && !isPreviewMode && (_jsx(FavoriteCTA, { dark: dark, showBorder: isDesktop ? showBorder : false }))] }));
};
